/**
 * Terms and Conditions Version Manager
 * 
 * This module dynamically loads all T&C versions from either the default
 * or custom folder based on config.js settings.
 * 
 * File naming convention: v{number}-{YYYY-MM-DD}.md
 * Example: v1-2026-02-02.md
 */

import termsConfig from './config';

// Dynamically import all markdown files from the appropriate folder
const loadTermsVersions = () => {
    const folderName = termsConfig.useCustom ? 'custom' : 'default';
    
    // Use Vite's glob import for dynamic loading
    const modules = import.meta.glob([
        './default/v*.md',
        './custom/v*.md'
    ], { eager: true, query: '?raw', import: 'default' });
    
    const versions = [];
    const prefix = `./src/content/terms/${folderName}/`;
    
    Object.keys(modules).forEach(path => {
        if (path.includes(`/${folderName}/`)) {
            // Extract version number and date from filename
            // Expected format: ./default/v1-2026-02-02.md or ./custom/v2-2026-03-15.md
            const filename = path.split('/').pop();
            const match = filename.match(/^v(\d+)-(\d{4}-\d{2}-\d{2})\.md$/);
            
            if (match) {
                versions.push({
                    version: parseInt(match[1]),
                    effectiveDate: match[2],
                    filename: filename,
                    content: modules[path]
                });
            }
        }
    });
    
    // Sort by version number (highest first)
    versions.sort((a, b) => b.version - a.version);
    
    return versions;
};

export const versions = loadTermsVersions();
export const current = versions.length > 0 ? versions[0] : null;
export const config = termsConfig;

export default {
    versions,
    current,
    config
};
